export default function Footer() {
  return (
    <footer className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-gray-300 py-10 flex flex-col	items-center">
      <div className="grid md:grid-cols-4 gap-6 px-6 w-full max-w-6xl justify-items-center">
        {/* Marca con icono */}
        <div className="flex flex-col	items-start">
          <img
            src="/faviconfooter.png"
            alt="Buksy Logo"
            className="w-14 h-15 object-contain mb-2 ml-22x"
          />
          <p className="text-sm text-gray-400 max-w-xs">
            Reservas inteligentes con IA para una experiencia gastronómica sin complicaciones.
          </p>

          <div className="flex gap-3 mt-3">
            {/* Redes sociales */}
            <button className="hover:text-white transition-colors" aria-label="Twitter">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5	w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 4.557a9.93 9.93 0 0 1-2.828.775A4.932 4.932 0 0 0	24 2.04a9.864 9.864 0 0 1-3.127 1.195 4.916 4.916 0 0 0-8.38 4.482A13.94 13.94 0 0	1 1.671 3.149 4.916 4.916 0 0 0 3.195 9.723 4.902 4.902 0 0 1	.964 9.1v.062a4.916 4.916 0 0 0 3.946 4.814 4.902 4.902 0 0	1-2.212.084 4.918 4.918 0 0 0 4.59 3.417 9.867 9.867 0 0	1-6.102 2.105c-.395 0-.787-.023-1.175-.068a13.945 13.945 0 0 0 7.548 2.212c9.056 0 14.01-7.506 14.01-14.01 0-.213-.005-.425-.014-.636A10.012 10.012 0 0 0 24 4.557z" />
              </svg>
            </button>

            {/* Instagram */}
{/* Instagram */}
<a
  href="https://www.instagram.com/buksy.reservas/"
  target="_blank"
  rel="noopener noreferrer"
  className="hover:text-white transition-colors"
  aria-label="Instagram"
>
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    className="h-5 w-5"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
</a>


            {/* Facebook */}
            <a
              href="https://www.facebook.com/buksy.reservas"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
              aria-label="Facebook"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5	w-5" fill="currentColor" viewBox="0 0 24	24">
                <path d="M22.675 0h-21.35C.597 0 0 .598 0 1.333v21.334C0 23.403.597 24 1.325 24H12.82v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.894-4.788 4.66-4.788 1.325 0 2.463.098 2.794.142v3.24l-1.918.001c-1.504 0-1.794.716-1.794 1.763v2.31h3.587l-.467 3.622h-3.12V24h6.116c.728 0 1.325-.597 1.325-1.333V1.333C24 .598 23.403 0 22.675 0z" />
              </svg>
            </a>

            {/* WhatsApp  */}
            <button className="hover:text-white transition-colors" aria-label="WhatsApp">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.52 3.48a11.94 11.94 0 0 0-16.91 0c-4.69 4.69-4.69 12.29 0 16.97l-1.31 4.8 4.95-1.31a11.92 11.92 0 0 0 16.91-16.97zM12.02 21c-2.14 0-4.24-.66-5.96-1.89l-.42-.25-2.95.78.79-2.88-.27-.44a9.964 9.964 0 1 1 9.81 4.18zM16.84 14.18c-.23-.12-1.37-.68-1.58-.76-.21-.08-.37-.12-.53.12-.16.23-.62.76-.76.92-.14.16-.28.18-.51.06-.23-.12-1-.37-1.9-1.18-.7-.62-1.17-1.39-1.31-1.62-.14-.23-.02-.35.10-.47.10-.10.23-.28.35-.42.12-.14.16-.23.23-.38.08-.14.04-.27-.02-.38-.06-.12-.53-1.28-.73-1.74-.19-.45-.38-.38-.53-.38-.14 0-.30 0-.46 0-.16 0-.42.06-.64.27-.21.21-.80.78-.80 1.9s.82 2.2.94 2.36c.12.16 1.63 2.5 3.95 3.5 2.33 1 2.33.67 2.75.62.42-.06 1.37-.55 1.56-1.08.19-.53.19-.98.14-1.08-.04-.10-.16-.16-.35-.27z" />
              </svg>
            </button>

          </div>
        </div>

        {/* Producto */}
        <div>
          <h4 className="font-semibold text-white mb-3">Producto</h4>
          <ul className="space-y-1 text-sm">
            <li><button className="hover:text-white hover:underline transition">Funciones</button></li>
            <li><button className="hover:text-white hover:underline transition">Precios</button></li>
            <li><button className="hover:text-white hover:underline transition">Integraciones</button></li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-white mb-3">Compañía</h4>
          <ul className="space-y-1 text-sm">
            <li><button className="hover:text-white hover:underline transition">Sobre nosotros</button></li>
            <li><button className="hover:text-white hover:underline transition">Blog</button></li>
            <li><button className="hover:text-white hover:underline transition">Carreras</button></li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-white mb-3">Legal</h4>
          <ul className="space-y-1 text-sm">
            <li><button className="hover:text-white hover:underline transition">Privacidad</button></li>
            <li><button className="hover:text-white hover:underline transition">Términos</button></li>
            <li><button className="hover:text-white hover:underline transition">Cookies</button></li>
          </ul>
        </div>
      </div>

      <div className="mt-8 text-center text-sm text-gray-500">
        © 2025 Buksy. Todos los derechos reservados.
      </div>
    </footer>
  );
}
